<template>
    <div class="block max-w-4xl mx-auto bg-white rounded-lg shadow p-3">
        <p class="text-lg mb-2 text-gray-700">{{ label }}</p>
        <!--        <input-text label="Alt" v-model="alt" :error="errors['alt'] ? errors['alt'][0] : null"/>-->
        <vue-dropzone
            @vdropzone-max-files-exceeded="limitFiles"
            @vdropzone-success="fileUploaded"
            @vdropzone-error="handleError"
            @vdropzone-sending="sendingEvent"
            class="mt-1"
            ref="myVueDropzone"
            :options="dropzoneOptions"
            id="image-upload"
        ></vue-dropzone>
        <error :error="errors['file'] ? errors['file'][0] : null" />
    </div>
</template>

<script>
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import siteLanguage from '../../config/siteLanguage'
export default {
    name: "InputImage",
    components: {
        vueDropzone: vue2Dropzone,
    },
    props: {
        label: String,
        name: String,
        language: {
            type: Object,
            default: () => {
                return { iso: siteLanguage.iso.ENGLISH };
            },
        },
        uploadRoute: String,
    },
    data: function () {
        return {
            dropzoneOptions: {
                url:
                    this.uploadRoute ||
                    route("api.media.store", this.language.iso),
                thumbnailWidth: 150,
                maxFilesize: 3,
                // maxFiles: 1,
                headers: {
                    "X-CSRF-TOKEN": document
                        .querySelector('meta[name="csrf-token"]')
                        .getAttribute("content"),
                    "X-Requested-With": "XMLHttpRequest",
                },
            },
            // alt: '',
            errors: {},
        };
    },
    methods: {
        sendingEvent(file, xhr, formData) {
            // formData.append('alt', this.alt);
        },
        limitFiles(file) {
            this.$refs.myVueDropzone.removeFile(file);
        },
        handleError(file, message, xhr) {
            if (xhr?.status === 422) {
                this.errors = message.errors;
            }
            this.$refs.myVueDropzone.removeFile(file);
        },
        fileUploaded(file, response) {
            this.$emit("uploaded", response);
            this.errors = {};
            this.$refs.myVueDropzone.removeFile(file);
        },
    },
    watch: {
        uploadRoute: function(newValue){
            this.dropzoneOptions.url = newValue;
            this.$refs.myVueDropzone.dropzone.options.url = newValue;
            this.$forceUpdate();
        }
    }
};
</script>
